import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const Layout = ({ children, vehicleName, noFooterPad }) => {
  return (
    <div className="relative min-h-screen bg-[#EEF3FC]">
      <div className="aurora-bg" />
      <div className="aurora-grid" />
      <div className="grain" />
      <Navbar />
      <main className={noFooterPad ? "" : "pt-20"}>{children}</main>
      <Footer />
      <WhatsAppButton vehicleName={vehicleName} />
    </div>
  );
};
